import { Col, ColProps } from "react-bootstrap";
import { TableFiltersWrapperModel } from "./tableFiltersModel";

export const TableFiltersWrapper = ({ children }: TableFiltersWrapperModel) => {
  return (
    <form>
      <div className="table-filters-wrapper-v2">{children}</div>
    </form>
  );
};

export const TableFilters = ({ children }: { children: React.ReactNode }) => {
  return <div className="table-filters">{children}</div>;
};

export const TableFilterInputWrapper = ({
  children,
  ...props
}: {
  children: React.ReactNode;
} & ColProps) => {
  return (
    <Col className="table-filter-input-wrapper" {...props}>
      <div className="table-filter-input-col">{children}</div>
    </Col>
  );
};
